import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";

const ORDER_MARK = "OrderMark";

export default class OrderMarkConfig extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            fields: {},
            otterFields:{},
            errors: {},
            isLoaded: true,
            activeLocation:'',
            oiConfigExist:false, // check the OrderMark old config is exist or not
            isOrderMarkEnabed: true,
            isOrderMarkConfigExist: false,
            isOtterConfigExist: false,
            // isBtnDisabled: true
        }

        this._bind(
            'handleChangeToggle',
            'renderOrderMarkRow',
            'renderOtterConfigRow',
            'renderSubmitFormButton',
            'handleCancel'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        },()=>{
            this.loadOrderMarkOrOtterConfig();
        });

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null && nextProps.isLoaded == true) {
            this.setState({
                    activeLocation: nextProps.activeLocation
                },
                () => {
                    this.loadOrderMarkOrOtterConfig();
                });
        }
    }

    loadOrderMarkOrOtterConfig() {

        let self = this;
        let activeLocation = this.state.activeLocation;
        let defaultStatus = "inactive";
        let defaultOMLocationId = "";

        if (!Utils.isEmptyObj(activeLocation)) {

            let pvtConfig = activeLocation.pvtConfig;
            if (!Utils.isEmptyObj(pvtConfig)) {

                // Check if the Old OrderMark oiConfig is exist then show message to user
                if(self.checkOIConfig(pvtConfig)){

                    self.setState({
                        oiConfigExist:true,
                    });

                } else {

                    let omSyncConfig = pvtConfig.omSyncConfig;
                    let orderMarkConfig = false;

                    if (!Utils.isEmptyObj(omSyncConfig)) {

                        let omLocationId = omSyncConfig.omLocationId;
                        let isSyncActive = omSyncConfig.isSyncActive;
                        orderMarkConfig  = true;

                        if (!Utils.isEmpty(omLocationId)) {
                            defaultOMLocationId = omLocationId;
                        }

                        if (isSyncActive && isSyncActive == true) {
                            defaultStatus = "active";
                        }
                    }

                    self.setState({
                        oiConfigExist:false,
                        isOrderMarkConfigExist: orderMarkConfig,
                        fields: {
                            status: defaultStatus,
                            omLocationId: defaultOMLocationId,
                        },
                    });

                }

                //check and update otterConfig
                let otterConfig = pvtConfig.otterConfig;
                if(!Utils.isEmptyObj(otterConfig) && !Utils.isEmpty(pvtConfig.otterConfig.storeId)){
                    let otterConfig = pvtConfig.otterConfig;
                    this.setState({
                        isOtterConfigExist: true,
                        isOrderMarkConfigExist: false,
                        fields: {
                            storeId: otterConfig.storeId,
                        },
                    });
                }

            } else {
                self.setState({
                    // isLoaded: true,
                    fields: {
                        status: defaultStatus,
                    },
                    oiConfigExist:false,
                    isOrderMarkEnabed: true
                });

            }
        }

    }


    handleChangeToggle = (field, e) => {

        this.loadOrderMarkOrOtterConfig();

        this.setState({
            isOrderMarkEnabed: field,
            errors: {},
            isBtnDisabled: false
        });
    };

    // Check the old OrderMark configuration is exist or not
    checkOIConfig(pvtConfig) {

        if (!Utils.isEmptyObj(pvtConfig)) {

            // check the oiConfig is exist or not
            let oiConfig = pvtConfig.oiConfig;
            if (!Utils.isEmptyObj(oiConfig)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }


    }

    //check if omSyncConfig exists
    checkOMSyncConfig(pvtConfig) {

        if (!Utils.isEmptyObj(pvtConfig)) {

            // check the oiConfig is exist or not
            let omSyncConfig = pvtConfig.omSyncConfig;
            if (!Utils.isEmptyObj(omSyncConfig)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }


    }

    handleChange(field, e) {

        let fields = this.state.fields;
        fields[field] = e.target.value;

        let statusValue = e.target.value;

        let status = false;
        if (statusValue == "active") {
            status = true;
        }

        // if we change only the status field then directly update the database
        if (field == "status"){
            this.updateOrderMarkStatusToDatabase(status);
        }

        this.setState({fields, isBtnDisabled: false, errors: {} });
    }

    updateOrderMarkStatusToDatabase(status){

        let self = this;
        self.setState({
            isLoaded : false,
            errors: {}
        });

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();

        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;

        let paramsObject = {
            "locId"         : locId,
            "activate"     : status
        };

        Api.orderMarkLocationActivation(userId, sessionToken, paramsObject)
            .then(
                (result) => {
                    const response = result.data;
                    if(response.success){
                        alert("OrderMark configuration updated successfully.")
                    }
                    self.setState({
                        isLoaded : true,
                        errors:{}
                    });

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    let errorMsg = error.responseJSON.error.message;
                    let errors = {};
                    errors["errors"] = errorMsg;
                    alert(errorMsg);
                    this.setState({
                        isLoaded : true,
                        errors: errors,
                        fields: {
                            status: 'inactive',
                        },
                    });
                    console.log("Error occured while fetching latest location data!");
                }
            );

    }

    handleValidation() {

        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        let self = this;

        let activeLocation = this.state.activeLocation;

        let pvtConfig = {};

        if (!Utils.isEmptyObj(activeLocation)) {
            pvtConfig = activeLocation.pvtConfig;
        }

        //check if orderMark config exists in database;
        let omSyncConfigExists = self.checkOMSyncConfig(pvtConfig);

        if (this.state.isOrderMarkEnabed) {
            let omLocationId = fields["omLocationId"];
            fields["omLocationId"] = omLocationId.replaceAll(' ', '');

            if ((Utils.isEmpty(omLocationId) || omLocationId.trim() === "") && (!omSyncConfigExists || fields["status"] == "active")) {
                formIsValid = false;
                errors["omLocationId"] = "OrderMark location id cannot be empty";
            }

        }else if(!this.state.isOrderMarkEnabed){

            let otterStoreId = fields["storeId"];

            if(!otterStoreId){
                formIsValid = false;
                errors["storeId"] = "Store id cannot be empty";
            }else{
                // validations for empty string
                if(otterStoreId.trim() === ""){
                    formIsValid = false;
                    errors["storeId"] = "Otter Store id cannot be empty";
                }

                fields["storeId"] = otterStoreId.replaceAll(' ','');
            }
        }else{
            formIsValid = false;
            errors["errors"] = "Please enter OrderMark/Otter configurations.";
        }

        this.setState({errors: errors, fields: fields});
        return formIsValid;
    }

    updateLocationFormSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){
            let activeLocation = this.state.activeLocation;
            let locId = activeLocation.objectId;
            let fields = this.state.fields;

            let self = this;
            self.setState({
                isLoaded : false,
                errors: {}
            });


            let pvtConfig = activeLocation.pvtConfig;

            let parameterObject = {};
            let paramsObject = {};
            let paramsObjectOtterConfig = {};

            // step - 1
            // Order mark config
            let omLocationId = "";
            if(!Utils.isEmpty(fields["omLocationId"])){
                omLocationId = fields["omLocationId"];
                let status = false;

                if (fields.hasOwnProperty("status") && fields.status === "active") {
                    status = true
                }

                paramsObject = {
                    "omLocationId": omLocationId.trim(),
                    "isSyncActive": status,
                };
            }

            let otterStoreId = "";
            if(!Utils.isEmpty(fields["storeId"])){
                otterStoreId = fields["storeId"];
                paramsObjectOtterConfig["storeId"] = otterStoreId.trim();
            }

            if (!Utils.isEmptyObj(pvtConfig)) {
                let pvtConfigCopy = pvtConfig;

                if(this.state.isOrderMarkEnabed) {

                    //remove ordermark config
                    if (Utils.isEmpty(fields["omLocationId"]) && fields["status"] == "inactive") {
                        let newPVtConfigCopy = Object.keys(pvtConfigCopy)
                            .filter(key => key != "omSyncConfig")
                            .reduce((acc, key) => {
                                acc[key] = pvtConfigCopy[key];
                                return acc;
                            }, {});

                        parameterObject["pvtConfig"] = newPVtConfigCopy;
                    } else {

                        pvtConfigCopy["omSyncConfig"] = paramsObject;
                        parameterObject["pvtConfig"] = pvtConfigCopy;
                    }


                }else if (!this.state.isOrderMarkEnabed){
                    let pvtConfigOtter = activeLocation.pvtConfig;
                    pvtConfigOtter["otterConfig"] = paramsObjectOtterConfig;
                    parameterObject["pvtConfig"] = pvtConfigOtter;

                }else{

                    let error = {};
                    error["errors"] = "Please enter OrderMark/Otter configurations.";
                    self.setState({
                        isLoaded: true,
                        errors: error
                    });
                    return;
                }


            }else{
                parameterObject["pvtConfig"] = {};
                // add new object
                // parameterObject["pvtConfig"] = {
                //     "omSyncConfig": paramsObject,
                //     "autoConfig":autoConfigObject
                // };

                if(this.state.isOrderMarkEnabed){
                    parameterObject["pvtConfig"]["omSyncConfig"] = paramsObject;
                }else if(!this.state.isOrderMarkEnabed){
                    parameterObject["pvtConfig"]["otterConfig"] = paramsObjectOtterConfig;
                }else {
                    let error = {};
                    error["errors"] = "Please enter OrderMark/Otter configurations.";
                    self.setState({
                        isLoaded: true,
                        errors: error
                    });
                    return;
                }

            }

            // add the location id in objectId key
            parameterObject["objectId"] = locId;
            //update the orderMarkConfig.
            this.updatePvtConfig(parameterObject);

        }

    }

    updatePvtConfig(paramsObject) {
        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;
        let pvtConfig = paramsObject.pvtConfig;

        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;

        let successMsg = `${this.state.isOrderMarkEnabed ? "OrderMark config" : "Otter config"} updated successfully.`

        if (this.state.isOrderMarkEnabed && !pvtConfig.hasOwnProperty("omSyncConfig")) {
            successMsg = "Ordermark config removed successfully.";
        }

        let self = this;

        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;


                    alert(successMsg);

                    self.setState({
                        isLoaded: true,
                        // isBtnDisabled: true
                    });

                    // Reload the data
                    self.props.reloadLocation();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded: true});
                    console.log("Error occured while fetching latest user data!");
                }
            );

    }

    handleCancel(){
       let self = this;

        self.setState({
            errors: {},
            // isBtnDisabled:true
        }, () => {
            self.props.reloadLocation();
        });
    };

    renderSubmitFormButton(){
        return(
            <div className="form-group">
                <button type="submit" className={this.state.isBtnDisabled ? "btn-save btn btn-export" : "btn btn-export"}>Save</button>
                <button type="button" className="btn btn-default back-button"
                        onClick={this.handleCancel}>Cancel
                </button>
            </div>
        );
    }

    renderOrderMarkRow(){

        let comp = null;

        if(this.state.oiConfigExist != true && this.state.isOtterConfigExist != true){
            comp = (
                <form name="updateLocationForm" className="updateLocationForm updateOtterForm" onSubmit= {this.updateLocationFormSubmit.bind(this)}>
                    <div className="row form-group" style={{marginBottom: 0}}>
                        <div className="col-lg-6">
                            <div className="form-group">
                                <div>
                                    <label htmlFor="labelName">OrderMark Location Id</label>
                                    <input type="text" className="form-control" id="omLocationId"
                                           ref="omLocationId"
                                           aria-describedby="omLocationId"
                                           placeholder="Enter OrderMark Location Id"
                                           onChange={this.handleChange.bind(this, "omLocationId")}
                                           value={this.state.fields["omLocationId"]}/>
                                    <span style={{color: "red"}}
                                          className="form-text">{this.state.errors["omLocationId"]}
                                            </span>
                                </div>

                            </div>
                        </div>


                    </div>

                    <hr style={{marginTop: 0}}></hr>

                    {
                        this.renderSubmitFormButton()
                    }

                    <hr></hr>

                    <div className="row form-group">
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor="exampleInputPassword1"><h4>OrderMark Sync location status<br/>
                                    <small className="form-text text-muted">You need to config auto accept as well if you are activating OrderMark service.

                                    </small></h4>

                                </label>
                                <div onChange={this.handleChange.bind(this, "status")}>
                                    <label className="radio-inline">
                                        <input type="radio" name="status" id="status1"
                                               value="inactive"
                                               checked={this.state.fields["status"] == 'inactive'}/> Inactive
                                    </label>
                                    <label className="radio-inline">
                                        <input type="radio" name="status" id="status2"
                                               value="active"
                                               checked={this.state.fields["status"] == 'active'}/> Active
                                    </label>
                                </div>
                                <span style={{color: "red"}}
                                      className="form-text mt-5">{this.state.errors["status"]}</span>
                            </div>
                            <div className="row col-lg-12">
                                {
                                    this.state.fields.status == 'active' ? (
                                        <h5>OrderMark connection is ACTIVE. Orders will be sent to the OrderMark.</h5>) : (
                                        <h5>OrderMark connection is NOT ACTIVE. Orders will NOT be sent to the OrderMark.</h5>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </form>
            );
        }else{
            comp = (
                <div className={"form-group mb-15"}>
                    Currently you are using the <b>{this.state.oiConfigExist ? "OrderMark" : "Otter"}</b> service. If you want to activate <b>OrderMark</b> Sync Api then contact the FreshBytes support team (support@freshbytes.io).
                </div>
            );
        }

        return comp;
    }

    renderOtterConfigRow(){
        let comp = null;

        if(!this.state.isOrderMarkConfigExist && !this.state.oiConfigExist){
            comp = (
                <form name="updateLocationForm " className="mt-20 updateLocationForm" onSubmit={this.updateLocationFormSubmit.bind(this)}>
                    <div className="row form-group">
                        <div className="col-lg-6">
                            <div className="form-group">
                                <label htmlFor="labelName">Otter Store Id</label>
                                <input type="text" className="form-control" id="storeId"
                                       ref="storeId"
                                       aria-describedby="storeId"
                                       placeholder="Enter Otter Store Id"
                                       onChange={this.handleChange.bind(this, "storeId")}
                                       value={this.state.fields["storeId"] || ""}
                                />
                                <span style={{color: "red"}}
                                      className="form-text mt-5">{this.state.errors["storeId"]}
                            </span>
                            </div>
                        </div>
                    </div>

                    <hr></hr>
                    {
                        this.renderSubmitFormButton()
                    }
                    <hr></hr>

                </form>

            );
        }else{
            comp = (
                <div className={"form-group mt-20 mb-15"}>
                    Currently you are using the <b>OrderMark</b> service. If you want to activate <b>Otter</b> Service then contact the FreshBytes support team (support@freshbytes.io).
                </div>
            );
        }

        return comp;
    }


    render() {

        return (
            <div className="order-mark">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.errors["errors"] ? (
                        <div className="alert alert-danger text-center" role="alert">
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                }
                        <div className="border-class otter-container marginTop">
                            <div  className="page-header" style={{paddingBottom: "14px", margin: "20px 20px"}}>
                                <btn
                                    className={this.state.isOrderMarkEnabed ? "btn btn-otter-active " : "btn btn-otter" }
                                    onClick={this.handleChangeToggle.bind(this, true)}
                                >
                                    Ordermark Sync
                                </btn>

                                <btn
                                    className={!this.state.isOrderMarkEnabed ? "btn btn-otter-active" : "btn btn-otter"}
                                    style={{marginLeft: "10px", padding: "2px 28px"}}
                                    onClick={this.handleChangeToggle.bind(this, false)}
                                >
                                    Otter Sync
                                </btn>

                            </div>

                            <div className={"mt-20 otter-tab"} style={{padding: "0 20px"}}>
                                <h4>Update {this.state.isOrderMarkEnabed ? "OrderMark" : "Otter"} Sync Configuration</h4>
                            </div>

                            <div style={{padding: "0 20px"}}>
                                <div className={"border-class mt-20 mb-20"} style={{padding: "0 20px"}}>

                                    {
                                        this.state.isOrderMarkEnabed  ? (
                                            <div className={"mt-20"}>
                                                {
                                                    this.renderOrderMarkRow()
                                                }
                                            </div>
                                        ) : this.renderOtterConfigRow()
                                    }
                                </div>
                            </div>



                        </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/order-mark-config.js